import { ConfirmationDialog } from 'components/Dialogs';

const getCancelDialogOptions = (ContentComponent: () => React.ReactNode, callback: (...args: any[]) => void) => ({
  wrapper: ConfirmationDialog,
  content: ContentComponent,
  actions: [
    {
      label: 'Cancel',
      type: 'cancel',
    },
    {
      label: 'Delete',
      variant: 'contained',
      type: 'danger',
      callback,
    },
  ],
});

export default getCancelDialogOptions;
